import { Component, OnInit } from '@angular/core';

declare var $:any;

export interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}

export const ROUTES: RouteInfo[] = [
    { path: 'login', title: 'Login',  icon:'ti-unlock', class: '' },
    { path: 'user', title: 'User Profile',  icon:'ti-user', class: '' }
];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
    }
    isNotMobileMenu(){
        if($(window).width() > 991){
            return false;
        }
        return true;
    }

    logout() {
        localStorage.removeItem('selectedUser');
    }

}



// WEBPACK FOOTER //
// /Users/boriskolozsi/Documents/WWW/sps-web/src/app/sidebar/sidebar.component.ts